import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import ProjectCard from '../../components/projectCard/projectCard'
import { chipType } from '../../components/chip/chip'
import sandboxerOnlineImg from '../../imgs/sandboxerOnline.png'
import blackDesertImg from '../../imgs/blackDesert.png'
import archeageOnlineImg from '../../imgs/archeageOnline.png'
import sandboxerLargeImg from '../../imgs/projects/SandboxerOnline.png'
import blackDesertLargeImg from '../../imgs/projects/BlackDesertOnline.png'
import archeageLargeImg from '../../imgs/projects/ArcheAgeOnline.png'
import mygrowbookImg from '../../imgs/mygrowbook.png'
import mygrowbookLargeImg from '../../imgs/projects/Mygrowbook.png'
import { thumbnails as previewThumbnails } from '../../imgs/projectPreviewThumbnails'
import { thumbnails as largeThumbnails } from './projectThumbnails'

import './projects.scss'

type Project = {
  title: string
  description: string
  fromTo: string
  images: string[]
  imageThumbnails?: string[]
  technologies: chipType[]
  url?: string
  largeImage?: string
  largeImageThumbnail?: string
}

function Projects() {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = 'Projects | Dwain'
  }, [])

  const projects: Project[] = [
    {
      title: 'MyGrowbook.de',
      description: t('projects.mygrowbook.description'),
      fromTo: '2026 - ' + t('general.now'),
      images: [mygrowbookImg],
      imageThumbnails: [largeThumbnails.Mygrowbook],
      technologies: ['reactnative', 'react', 'typescript', 'android', 'nestjs', 'postgresql', 'redis', 'socketio', 'awss3', 'docker'],
      url: 'https://mygrowbook.de',
      largeImage: mygrowbookLargeImg,
      largeImageThumbnail: largeThumbnails.Mygrowbook
    },
    /*{
      title: 'Staige.tv / Soccerwatch.tv',
      description: t('projects.staige.description'),
      fromTo: '2020 - ' + t('general.now'),
      images: [staigeSoccerwatchImg],
      technologies: ['typescript', 'angular', 'node', 'googlecloud'],
      url: 'https://staige.tv'
    },*/
    {
      title: 'Sandboxer.de',
      description: t('projects.sandboxer.description'),
      fromTo: '2016 - 2018',
      images: [sandboxerOnlineImg],
      imageThumbnails: [previewThumbnails.sandboxerOnline],
      technologies: ['wordpress', 'html', 'scss'],
      largeImage: sandboxerLargeImg,
      largeImageThumbnail: largeThumbnails.SandboxerOnline
    },
    {
      title: 'BlackDesert-Online.de',
      description: t('projects.blackdesert.description'),
      fromTo: '2013 - 2020',
      images: [blackDesertImg],
      imageThumbnails: [previewThumbnails.blackDesert],
      technologies: ['wordpress', 'html', 'css'],
      largeImage: blackDesertLargeImg,
      largeImageThumbnail: largeThumbnails.BlackDesertOnline
    },
    {
      title: 'ArcheAge-Online.de',
      description: t('projects.archeage.description'),
      fromTo: '2011 - 2019',
      images: [archeageOnlineImg],
      imageThumbnails: [previewThumbnails.archeageOnline],
      technologies: ['joomla', 'wordpress', 'html', 'css'],
      largeImage: archeageLargeImg,
      largeImageThumbnail: largeThumbnails.ArcheAgeOnline
    }
  ]

  return (
    <main className='page-projects'>
      <div className='projects-content'>
        <header className='content-header'>
          <h1 className='header-title'>{t('projects.title')}</h1>
          <p className='header-subtitle'>{t('projects.subtitle')}</p>
        </header>

        <section className='content-list' aria-label="Project list">
          {projects.map((project, index) => (
            <ProjectCard
              key={index}
              title={project.title}
              description={project.description}
              fromTo={project.fromTo}
              images={project.images}
              imageThumbnails={project.imageThumbnails}
              technologies={project.technologies}
              url={project.url}
              largeImage={project.largeImage}
              largeImageThumbnail={project.largeImageThumbnail}
            />
          ))}
        </section>
      </div>
    </main>
  )
}

export default Projects
